export default __webpack_public_path__ + "static/media/bn-txt-img.c8a5c088.png";